export default __webpack_public_path__ + "2e490bed6549aec32b3b42ee3c2c834f.png";